/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { LineChartProps } from '../../LineChart.props';

/**
 * Parse LineChart props into a Highcharts format for the line data options.
 */
export const getLineChartLineData = (props: LineChartProps): Highcharts.Options => {
  const { legend, smooth, thresholds, plottingOptions } = props;

  const options = {} as Highcharts.Options;

  // Series (main)
  options.series = plottingOptions.map((line, index) => {
    const { data, lineWidth, seriesName, color, showMarkers } = line;
    const seriesOptions: Highcharts.SeriesOptionsType = {
      data,
      marker: {
        enabled: showMarkers,
      },

      states: {
        hover: {
          enabled: showMarkers,
        },
      },
      type: smooth ? 'spline' : 'line',
      ...(color ? { color } : {}),
      ...(lineWidth ? { lineWidth } : {}),
      ...(seriesName ? { name: seriesName } : {}),
    };

    if (legend) {
      seriesOptions.name = legend[index];
    }
    return seriesOptions;
  });

  // Y-axis plotLines (thresholds)
  if (!thresholds?.length) {
    return options;
  }
  const plotLines = thresholds.map((threshold) => {
    const plotLineOptions: Highcharts.YAxisPlotLinesOptions = {
      dashStyle: threshold.style || 'Dash',
      value: threshold.value,
      width: 2,
    };

    if (threshold.color) {
      plotLineOptions.color = threshold.color;
    }

    if (threshold.showLabel) {
      plotLineOptions.label = {
        style: {
          color: threshold.color,
        },
        text: String(threshold.value),
      };
    }

    return plotLineOptions;
  });

  options.yAxis = { plotLines };

  return options;
};
